// Add project specific javascript code and import of additional bundles here:

import Font from '@ckeditor/ckeditor5-font/src/font';
import { ckeditorConfigRegistry, ckeditorPluginRegistry, fieldRegistry, textEditorRegistry } from 'sulu-admin-bundle/containers';
import ArticlesEditor from './fields/ArticlesEditor';
import ArticlesEditorField from './fields/ArticlesEditorField';
import LightEditor from './fields/LightEditor';
import LightEditorField from './fields/LightEditorField';
import Capitalize from './src/ckplugins/Capitalize';

textEditorRegistry.add('lighteditor', LightEditorField);
textEditorRegistry.add('articleseditor', ArticlesEditorField);
fieldRegistry.add('lighteditor', LightEditor);
fieldRegistry.add('articleseditor', ArticlesEditor);
ckeditorPluginRegistry.add(Font);
ckeditorPluginRegistry.add(Capitalize);
ckeditorConfigRegistry.add((config) => {
	return {
		toolbar: [...config.toolbar, 'fontColor', 'uppercase'],

		fontColor: {
			colors: [
				{ label: 'Beige', color: '#EDE7D5' },
				{ label: 'Gold UAQ', color: '#FFC854' },
				{ label: 'Gold Masar', color: '#FFC854' },
				{ label: 'Dark Gold', color: '#CEB98A' },
				{ label: 'Dark Blue', color: '#1D434F' },
				{ label: 'Dark', color: '#0C1C21' },
				{ label: 'Dark Grey', color: '#848484' },
				{ label: 'White', color: '#FFFFFF' },
				{ label: 'Light Blue', color: '#AECDD2' },
				{ label: 'Very Light Gold', color: '#F6F4EF' },
				{ label: 'Medium gold', color: '#D9D4C8' },
			],
		},
	};
});
